window.K1FastBuy = function () {
	this.AJAXUrl = "/ajax/fast_buy_form.php"

	this.buttonClass = "open-modal-fast-buy-js"
	this.modalClass = "modal-fast-buy-js"

	this.body = document.querySelector("body")
	this.modal = document.querySelector(`.${this.modalClass}`)
	this.modalItem = this.modal.querySelector(".fast-buy-item")
	this.modalClose = document.querySelector(".fast-buy-close-js")
	this.modalButton = document.querySelector(".fast-buy-form__button")
	this.modalMainContent = document.querySelector(".modal-fast-buy__inner")
	this.modalSuccessContent = document.querySelector(".modal-fast-buy__success")

	BX.ready(BX.delegate(this.init, this))
}

window.K1FastBuy.prototype = {
	init: function () {
		this.bindElements()
	},

	createPlugBlock: function () {
		const skuPlug = document.createElement('div')
		const pricePlug = document.createElement('div')

		skuPlug.classList.add('sku-plug')
		pricePlug.classList.add('price-plug')

		return {
			sku: skuPlug,
			price: pricePlug
		}
	},

	getInteractiveElements: function () {
		return {
			sku: document.querySelector('.good-element__sku'),
			price: document.querySelector('.good-element__price-box'),
		}
	},

	getPlugElements: function () {
		// if ()
		return {
			sku: document.querySelector('.sku-plug'),
			price: document.querySelector('.price-plug'),
		}
	},

	getModalFields: function () {
		return {
			name: this.modal.querySelector('#fast-buy-form-name'),
			phone: this.modal.querySelector('#fast-buy-form-phone'),
			confirm: this.modal.querySelector('.fast-buy-form__confirm input'),
		}
	},

	dropElementsInModal: function () {
		const plugs = this.createPlugBlock()
		const orig = this.getInteractiveElements()

		if (orig.sku) orig.sku.before(plugs.sku)
		orig.price.before(plugs.price)

		if(orig.sku !== null) {
			this.modalItem.append(orig.sku)
		}
		this.modalItem.append(orig.price)
	},

	dropElementsFromModal: function () {
		const plugs = this.getPlugElements()
		const orig = this.getInteractiveElements()
		plugs.sku.before(orig.sku)
		plugs.price.before(orig.price)
		plugs.sku.remove()
		plugs.price.remove()

	},

	closeModalFastBuy: function (event) {
		const fields = this.getModalFields()
		const target = event.target

		if (target.closest(".modal__body ") && !target.closest(".fast-buy-close-js")) return false

		this.dropElementsFromModal()
		this.hideSuccessContent()

		fields.name.value = ""
		fields.phone.value = ""

		fields.phone.closest('.default-form-input-text-js').classList.remove('k1-focus', 'k1-error')
		fields.confirm.checked = false


		this.modal.style.display = "none"
		this.modal.classList.remove("opened")
		this.body.style.overflow = "auto"
	},

	showSuccessContent: function () {
		this.modalMainContent.classList.remove("active")
		this.modalSuccessContent.classList.add("active")
		ym(9755971,'reachGoal','zakazhite-v-1-klik')
		this.modal.classList.add("success")
		// $('.modal-installments-js').removeClass('success');


		setTimeout(() => {
			// Код для задержки на 5 секунд
			$('.modal-fast-buy__success').removeClass('active');
			$('.modal-fast-buy-js ').removeClass('opened');
			$('body').css('overflow','visible');
			$('.modal.modal-fast-buy-js').css('display','none');

		}, 5000);

	},

	hideSuccessContent: function () {
		this.modalMainContent.classList.add("active")
		this.modalSuccessContent.classList.remove("active")
		this.modal.classList.remove("success")
	},

	openModalFastBuy() {
		this.dropElementsInModal()
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')])
		this.modal.style.display = 'block'
		this.modal.classList.add("opened")
		this.body.style.overflow = "hidden"
		if (document.querySelector(".fast-buy-item__discount"))
			document.querySelector(".fast-buy-item__discount").textContent = document.querySelector(".good-element__discount").textContent
		if (this.modal.classList.contains("opened")) {
			BX.bind(this.modal, "click", BX.proxy(this.closeModalFastBuy, this))
			BX.bind(this.modalButton, "click", BX.proxy(this.sendDataFastBuyModal, this))
		}
	},

	getFormData: function () {
		return {
			goodId: "",
			quantity: 1,
			name: "",
			phone: "",
			price: "",
			sku: ""
		}
	},

	sendDataFastBuyModal: function (event) {
		event.preventDefault()
		const data = window.k1Forms.getDataFastBuyModal(event)

		if (!data)
			return false

		grecaptcha.ready(() => {
			grecaptcha.execute(
				document.querySelector('meta[name="google-recaptcha"]').content,
				{ action: 'fast_order' }
			).then((token) => {
				data.recaptcha = token

				fetch(this.AJAXUrl, {
					method: 'post',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(data),
				}).then(response => {
					return response.text()
				}).then(responseData => {
					let response = JSON.parse(responseData)
					if (response.status === true) {
						this.showSuccessContent()
						// console.log('recaptcha fast_order ')
					}
				})
			})
		})
	},

	bindElements() {
		BX.bind(BX(this.buttonClass), "click", BX.proxy(this.openModalFastBuy, this))
	}
}

if (document.querySelector(".good-element"))
	new K1FastBuy()

// window.dremVars.fastModal = null;
// if (!window.dremVars.FastModal && document.querySelector(".good-element")) window.dremVars.FastModal = new K1FastBuy();
